/**
=========================================================
* Material Dashboard 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * Brand color tokens aligned with investbamboo.com
 *
 * vault-darker  #0c231a   primary dark background / headings
 * vault-dark    #003930   dark green
 * vault         #004a3d   brand primary green
 * vault-light   #80a39e   muted sage (secondary text on light)
 * lemon         #e6ff55   accent / CTA
 * beige-light   #f9f5f0   page background
 * beige         #f4ede4   warm background
 * rouge         #b5162a   error / sell
 * green         #00a239   success
 */

export default {
  background: {
    default: '#fefdfc'
  },

  text: {
    main: '#80a39e',
    focus: '#80a39e'
  },

  transparent: {
    main: 'transparent'
  },

  white: {
    main: '#ffffff',
    focus: '#ffffff'
  },

  black: {
    light: '#0c231a',
    main: '#0c231a',
    focus: '#0c231a'
  },

  primary: {
    main: '#004a3d',
    focus: '#004a3d'
  },

  secondary: {
    main: '#80a39e',
    focus: '#80a39e'
  },

  info: {
    main: '#1A73E8',
    focus: '#1662C4'
  },

  success: {
    main: '#00a239',
    focus: '#00a239'
  },

  warning: {
    main: '#FADE4D',
    focus: '#F5B8A3'
  },

  error: {
    main: '#b5162a',
    focus: '#b5162a'
  },

  light: {
    main: '#fefdfc',
    focus: '#fefdfc'
  },

  dark: {
    main: '#0c231a',
    focus: '#003930'
  },

  grey: {
    100: '#F8F8F8',
    200: '#f0f2f5',
    300: '#E8E8E8',
    400: '#ced4da',
    500: '#adb5bd',
    600: '#6c757d',
    700: '#D4D4D4',
    800: '#343a40',
    900: '#595959'
  },

  gradients: {
    primary: {
      main: '#004a3d',
      state: '#003930'
    },

    secondary: {
      main: '#80a39e',
      state: '#ccdad8'
    },

    info: {
      main: '#4AABF2',
      state: '#36668A'
    },

    success: {
      main: '#00a239',
      state: '#007d2d'
    },

    warning: {
      main: '#FADE4D',
      state: '#8F8038'
    },

    error: {
      main: '#b5162a',
      state: '#8b1020'
    },

    light: {
      main: '#f9f5f0',
      state: '#f4ede4'
    },

    dark: {
      main: '#0c231a',
      state: '#001c18'
    }
  },

  socialMediaColors: {
    facebook: {
      main: '#3b5998',
      dark: '#344e86'
    },

    twitter: {
      main: '#55acee',
      dark: '#3ea1ec'
    },

    instagram: {
      main: '#125688',
      dark: '#0e456d'
    },

    linkedin: {
      main: '#0077b5',
      dark: '#00669c'
    },

    pinterest: {
      main: '#cc2127',
      dark: '#b21d22'
    },

    youtube: {
      main: '#e52d27',
      dark: '#d41f1a'
    },

    vimeo: {
      main: '#1ab7ea',
      dark: '#13a3d2'
    },

    slack: {
      main: '#3aaf85',
      dark: '#329874'
    },

    dribbble: {
      main: '#ea4c89',
      dark: '#e73177'
    },

    github: {
      main: '#24292e',
      dark: '#171a1d'
    },

    reddit: {
      main: '#ff4500',
      dark: '#e03d00'
    },

    tumblr: {
      main: '#35465c',
      dark: '#2a3749'
    }
  },

  badgeColors: {
    primary: {
      background: '#ccdad8',
      text: '#004a3d'
    },

    secondary: {
      background: '#d7d9e1',
      text: '#6c757d'
    },

    info: {
      background: '#aecef7',
      text: '#095bc6'
    },

    success: {
      background: '#c7f0d6',
      text: '#007d2d'
    },

    warning: {
      background: '#ffd59f',
      text: '#c87000'
    },

    error: {
      background: '#f7c8cc',
      text: '#b5162a'
    },

    light: {
      background: '#ffffff',
      text: '#80a39e'
    },

    dark: {
      background: '#ccdad8',
      text: '#0c231a'
    }
  },

  coloredShadows: {
    primary: '#004a3d',
    secondary: '#80a39e',
    info: '#00bbd4',
    success: '#00a239',
    warning: '#ff9900',
    error: '#b5162a',
    light: '#adb5bd',
    dark: '#0c231a'
  },

  logo: {
    leaves: '#f4ede4',
    bamboo: '#0c231a'
  },

  inputBorderColor: '#ccdad8',

  tabs: {
    indicator: { boxShadow: '#ddd' }
  }
};
